<template>
  <div class="tables-basic">
    <b-breadcrumb>
      <b-breadcrumb-item>Sale</b-breadcrumb-item>
      <b-breadcrumb-item active>New Credit Note</b-breadcrumb-item>
    </b-breadcrumb>
    <b-row>
      <b-col lg="12">
        <Widget title="<h5>New Credit Note</h5>" customHeader>
          <div>
            <b-form @submit="onSubmit" v-if="show">
              <b-row class="form-row">
                <b-col lg="4">
                  <b-form-group id="input-group-title" label="Title:" label-for="input-title">
                    <b-form-select id="input-title" v-model="item.title" :options="titles" />
                  </b-form-group>

                  <b-form-group
                    id="input-group-lastName"
                    label="Last Name:"
                    label-for="input-lastName"
                  >
                    <b-form-input
                      id="input-lastName"
                      v-model="item.lastName"
                      required
                      placeholder="Enter Last Name"
                    />
                  </b-form-group>

                  <b-form-group id="input-group-gender" label="Gender:" label-for="input-gender">
                    <b-form-select id="input-gender" v-model="item.gender" :options="genders" />
                  </b-form-group>

                  <b-form-group
                    id="input-group-existingFileNumber"
                    label="Existing File Number:"
                    label-for="input-existingFileNumber"
                  >
                    <b-form-input
                      id="input-existingFileNumber"
                      v-model="item.existingFileNumber"
                      placeholder="Enter Existing File Number"
                    />
                  </b-form-group>
                </b-col>

                <b-col lg="4">
                  <b-form-group
                    id="input-group-firstName"
                    label="First Name:"
                    label-for="input-firstName"
                  >
                    <b-form-input
                      id="input-firstName"
                      v-model="item.firstName"
                      required
                      placeholder="Enter First Name"
                    />
                  </b-form-group>

                  <b-form-group id="input-group-dob" label="Date of Birth:" label-for="input-dob">
                    <b-form-input
                      id="input-dob"
                      v-model="item.dob"
                      required
                      type="date"
                      placeholder="Enter DOB"
                    />
                  </b-form-group>

                  <b-form-group
                    id="input-group-bloodGroup"
                    label="Blood Group:"
                    label-for="input-bloodGroup"
                  >
                    <b-form-select
                      id="input-bloodGroup"
                      v-model="item.bloodGroup"
                      :options="blood_groups"
                    />
                  </b-form-group>
                </b-col>

                <b-col lg="4">
                  <b-form-group
                    id="input-group-middleName"
                    label="Middle Name:"
                    label-for="input-middleName"
                  >
                    <b-form-input
                      id="input-middleName"
                      v-model="item.middleName"
                      placeholder="Enter Middle Name"
                    />
                  </b-form-group>

                  <b-form-group
                    id="input-group-maritalStatus"
                    label="Marital Status:"
                    label-for="input-maritalStatus"
                  >
                    <b-form-select
                      id="input-maritalStatus"
                      v-model="item.maritalStatus"
                      :options="marital_statuses"
                      required
                    ></b-form-select>
                  </b-form-group>

                  <b-form-group
                    id="input-group-nssfNumber"
                    label="NSSF Number:"
                    label-for="input-nssfNumber"
                  >
                    <b-form-input
                      id="input-nssfNumber"
                      v-model="item.primaryNumber"
                      required
                      placeholder="Enter NSSF Number"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="form-row">
                <b-col lg="4">
                  <b-form-group
                    id="input-group-contact-mobileNumber"
                    label="Mobile:"
                    label-for="input-contact-mobileNumber"
                  >
                    <b-form-input
                      id="input-contact-mobileNumber"
                      v-model="item.contact.mobileNumber"
                      placeholder="Enter Mobile Number"
                    />
                  </b-form-group>

                  <b-form-group
                    id="input-group-contact-physicalAddress"
                    label="Physical Address:"
                    label-for="input-contact-physicalAddress"
                  >
                    <b-form-input
                      id="input-contact-physicalAddress"
                      v-model="item.contact.physicalAddress"
                      placeholder="Enter Physical Address"
                    />
                  </b-form-group>

                  <b-form-group
                    id="input-group-contact-nationality"
                    label="Nationality:"
                    label-for="input-contact-nationality"
                  >
                    <b-form-input
                      id="input-contact-nationality"
                      v-model="item.contact.nationality"
                      placeholder="Enter Nationality"
                    />
                  </b-form-group>
                </b-col>

                <b-col lg="4">
                  <b-form-group
                    id="input-group-contact-telephoneNumber"
                    label="Other Phone Number:"
                    label-for="input-contact-telephoneNumber"
                  >
                    <b-form-input
                      id="input-contact-telephoneNumber"
                      v-model="item.contact.telephoneNumber"
                      placeholder="Telephone Number"
                    />
                  </b-form-group>

                  <b-form-group
                    id="input-group-contact-postalAddress"
                    label="Postal Address:"
                    label-for="input-contact-postalAddress"
                  >
                    <b-form-input
                      id="input-contact-postalAddress"
                      v-model="item.contact.postalAddress"
                      placeholder="Enter Postal Address"
                    />
                  </b-form-group>

                  <b-form-group
                    id="input-group-contact-city"
                    label="City:"
                    label-for="input-contact-city"
                  >
                    <b-form-input
                      id="input-contact-city"
                      v-model="item.contact.city"
                      placeholder="Enter City"
                    />
                  </b-form-group>
                </b-col>

                <b-col lg="4">
                  <b-form-group
                    id="input-group-contact-email"
                    label="Email:"
                    label-for="input-contact-email"
                  >
                    <b-form-input
                      id="input-contact-email"
                      v-model="item.contact.email"
                      placeholder="Enter Email"
                    />
                  </b-form-group>

                  <b-form-group
                    id="input-group-contact-residence"
                    label="Residence:"
                    label-for="input-contact-residence"
                  >
                    <b-form-input
                      id="input-contact-residence"
                      v-model="item.contact.residence"
                      placeholder="Enter Residence"
                    />
                  </b-form-group>

                  <b-form-group
                    id="input-group-contact-country"
                    label="Country:"
                    label-for="input-contact-country"
                  >
                    <b-form-input
                      id="input-contact-country"
                      v-model="item.contact.country"
                      placeholder="Enter Country"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="form-row">
                <b-col lg="4">
                  <b-form-group
                    id="input-group-nok-relationship"
                    label="NOK Relationship:"
                    label-for="input-nok-relationship"
                  >
                    <b-form-select
                      id="input-nok-relationship"
                      v-model="item.nok.relationship"
                      :options="relationships"
                      required
                    ></b-form-select>
                  </b-form-group>

                  <b-form-group
                    id="input-group-nok-physicalAddress"
                    label="NOK Physical Address:"
                    label-for="input-nok-physicalAddress"
                  >
                    <b-form-input
                      id="input-nok-contact-physicalAddress"
                      v-model="item.nok.contact.physicalAddress"
                      placeholder="Enter NOK Physical Address"
                    />
                  </b-form-group>
                </b-col>

                <b-col lg="4">
                  <b-form-group
                    id="input-group-nok-firstName"
                    label="Nok Firstname:"
                    label-for="input-nok-firstName"
                  >
                    <b-form-input
                      id="input-nok-firstName"
                      v-model="item.nok.firstName"
                      placeholder="Enter NOK First Name"
                    />
                  </b-form-group>

                  <b-form-group
                    id="input-group-nok-contact-mobileNumber"
                    label="NOK Mobile:"
                    label-for="input-nok-contact-mobileNumber"
                  >
                    <b-form-input
                      id="input-nok-contact-mobileNumber"
                      v-model="item.nok.contact.mobileNumber"
                      placeholder="Enter NOK Mobile Number"
                    />
                  </b-form-group>
                </b-col>

                <b-col lg="4">
                  <b-form-group
                    id="input-group-nok-firstName"
                    label="Nok Last Name:"
                    label-for="input-nok-lastName"
                  >
                    <b-form-input
                      id="input-nok-lastName"
                      v-model="item.nok.lastName"
                      placeholder="Enter NOK Last Name"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-button type="submit" variant="primary">Submit</b-button>
            </b-form>
          </div>
        </Widget>
      </b-col>
    </b-row>

    <b-modal ref="error_modal" id="error_modal" title="Opps !">
      <p class="my-4">Error occured during save : {{ err_mesage }}</p>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import Widget from "@/components/Widget/Widget";
import userApi from "@/services/userApi";
/*
import patientApi from "@/services/patientApi";
import relationshipApi from "@/services/relationshipApi";
import titleApi from "@/services/titleApi";
import maritalStatusApi from "@/services/maritalStatusApi";
import bloodGroupApi from "@/services/bloodGroupApi";
import genderApi from "@/services/genderApi";
*/
export default {
  name: "PatientEdit",
  components: { Widget },
  data() {
    return {
      item: {
        title: "",
        firstName: "",
        middleName: "",
        lastName: "",
        dob: null,
        gender: "",
        maritalStatus: "",
        bloodGroup: "",
        primaryNumber: "",
        contact: {
          mobileNumber: "",
          telephoneNumber: "",
          email: "",
          physicalAddress: "",
          postalAddress: "",
          residence: "",
          nationality: "",
          city: "",
          country: ""
        },
        existingFileNumber: "",
        nok: {
          firstName: "",
          middleName: "",
          lastName: "",
          relationship: "",
          contact: {
            mobileNumber: "",
            telephoneNumber: "",
            email: "",
            physicalAddress: "",
            postalAddress: "",
            residense: "",
            nationality: "",
            city: "",
            country: ""
          }
        }
      },
      err_mesage: "",
      titles: [{ text: "Select One", value: "" }],
      relationships: [{ text: "Select One", value: "" }],
      marital_statuses: [{ text: "Select One", value: "" }],
      blood_groups: [{ text: "Select One", value: "" }],
      genders: [{ text: "Select One", value: "" }],
      show: true
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.saveItem(this.$route.params.id, this.item);
    },
    getByID(id) {
      if (id > 0) {
        patientApi
          .getByID(id)
          .then(response => {
            this.item = response;
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    saveItem(id, value) {
      if (id > 0) {
        patientApi
          .update(id, value)
          .then(response => {
            this.item = response;
            this.onSaved(true, "");
          })
          .catch(error => {
            console.log(error);
            this.onSaved(false, error);
          });
      } else {
        patientApi
          .create(value)
          .then(response => {
            this.item = response;
            this.onSaved(true, "");
          })
          .catch(error => {
            console.log(error);
            this.onSaved(false, error);
          });
      }
    },
    onSaved(sucessful, error_msg) {
      if (sucessful) {
        this.$router.push("/app/patient/" + this.item.id);
      } else {
        this.err_mesage = error_msg;
        this.$refs["error_modal"].show();
      }
    },
    intializeOptions() {
      relationshipApi
        .getAll()
        .then(response => {
          this.updateElements(response, this.relationships);
        })
        .catch(error => {
          console.log(error);
        });

      titleApi
        .getAll()
        .then(response => {
          this.updateElements(response, this.titles);
        })
        .catch(error => {
          console.log(error);
        });

      maritalStatusApi
        .getAll()
        .then(response => {
          this.updateElements(response, this.marital_statuses);
        })
        .catch(error => {
          console.log(error);
        });

      bloodGroupApi
        .getAll()
        .then(response => {
          this.updateElements(response, this.blood_groups);
        })
        .catch(error => {
          console.log(error);
        });

      genderApi
        .getAll()
        .then(response => {
          this.updateElements(response, this.genders);
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateElements(response, ui_array) {
      for (var i = 0; i < response.length; i++) {
        var obj = response[i];
        var option = {
          text: obj.name,
          value: obj
        };
        ui_array.splice(1, ui_array);
        ui_array.push(option);
      }
    }
  },
  computed: {
    getEditStatus() {
      return this.$route.params.id < 1 ? "New" : "Edit";
    }
  },
  mounted() {
    //this.intializeOptions();
    //this.getByID(this.$route.params.id);
  },
  created() {
    userApi.isLoggedIn(this.$router);
  }
};
</script>

<style src="./Style.scss" lang="scss" scoped />
